module.exports = __webpack_public_path__ + "new-agent/static/fonts/MaterialIconsRound-Regular.2a9ce55.otf";